import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Route, Switch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import routes from '../routes';
import AppBar from '../components/AppBar';
import Drawer from '../components/Drawer';
import Toastify from '../components/Toastify';
import { fetchHealthStatus } from '../store/actions/health-status';
import { fetchSelfInfo } from '../store/actions/admins';
import { isSelfInfoFetching } from '../store/getters/admins';
import LoadingPage from '../pages/master/MasterLoading';
import ModeDisplayBar from '../components/ModeDisplayBar/ModeDisplayBar';
import { fetchConfig } from '../store/actions/config';
import { timeoutPromise } from '../utils';
import { fetchAlgoConfig } from '../store/actions/algos';
import { isConfigMounted } from '../store/getters/config';
import { changePageTitleModifierBrokerWise } from '../helpers/title-modifiers';

const getRoutes = () => {
  return routes.map((props) => (
    <Route
      key={props.id}
      path={props.path}
      render={(p) => <props.component {...p} />}
      exact={props.exact}
      strict={props.strict}
    />
  ));
};

// eslint-disable-next-line react/display-name
export default function () {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const history = useHistory();
  const isConfigMountedDone = useSelector(isConfigMounted);

  const dismissPanel = () => {
    setIsOpen(false);
  };

  const openPanel = () => {
    setIsOpen(true);
  };

  // for checking token
  useEffect(() => {
    dispatch(fetchSelfInfo());
  }, [dispatch]);

  useEffect(() => {
    const delayedFetchHealth = () => {
      setTimeout(() => {
        dispatch(fetchHealthStatus());
      }, 1000);
    };

    history.listen((location, action) => {
      if (!location || !location.pathname) {
        return;
      }

      if (action === 'PUSH') {
        if (location.pathname.startsWith('/users')) {
          delayedFetchHealth();
        }
      } else if (action === 'POP') {
        if (
          location.hash &&
          (location.hash.startsWith('#tab=algos') ||
            location.hash.startsWith('#page'))
        ) {
          delayedFetchHealth();
        }
      }
    });
  }, [dispatch, history]);

  useEffect(() => {
    dispatch(fetchConfig());
    dispatch(fetchAlgoConfig());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isConfigMountedDone) {
      return;
    }

    const healthFetch = async () => {
      try {
        await timeoutPromise(1000);
        await dispatch(fetchHealthStatus());
      } finally {
        setTimeout(healthFetch, 30000);
      }
    };

    healthFetch();
  }, [dispatch, isConfigMountedDone]);

  const isFetching = useSelector(isSelfInfoFetching);

  useEffect(() => {
    changePageTitleModifierBrokerWise();
  }, []);

  if (isFetching) {
    return (
      <div className="master">
        <LoadingPage />
      </div>
    );
  } else {
    return (
      <div className="master">
        <div className="master__page">
          <AppBar openPanel={openPanel} />
          <ModeDisplayBar />
          <Drawer isOpen={isOpen} dismissPanel={dismissPanel} />
          <main className="main">
            <React.Suspense fallback={<span />}>
              <Switch>{getRoutes(routes)}</Switch>
            </React.Suspense>
          </main>
        </div>
        <Toastify />
      </div>
    );
  }
}
